import tokens from './tokens';

/**
 * Legacy palette shape, retuned to the brand tokens (see tokens.js).
 *
 * The numeric slots are kept because ~40 files import this object directly.
 * New code should read from `tokens` (or the MUI theme) instead; these slots
 * are re-mapped onto the token values so existing call sites pick up the
 * redesign without churn.
 */
const palette = {
  white: '#FFFFFF',
  primary: {
    10: tokens.colors.primarySoft,
    20: tokens.colors.primaryTint,
    30: '#74A3AC',
    40: tokens.colors.primaryDeep,
    50: tokens.colors.primary,
    80: tokens.colors.primaryDeep,
    90: tokens.colors.primaryDark,
    100: tokens.colors.hover,
  },
  secondary: {
    10: tokens.colors.primaryDeep,
    40: '#3C585D',
    50: '#E8890C',
  },
  grey: {
    10: tokens.colors.hover,
    20: tokens.colors.border,
    30: tokens.colors.borderStrong,
    40: tokens.colors.inkFaint,
    50: tokens.colors.inkMuted,
    60: tokens.colors.inkSecondary,
    70: tokens.colors.inkSecondary,
    80: tokens.colors.ink,
    90: '#102226',
    100: '#EAF1F1',
  },
  success: {
    10: tokens.colors.success.bg,
    20: '#C9EBCF',
    50: tokens.colors.success.fg,
    60: tokens.colors.success.main,
    70: tokens.colors.success.bg,
    80: '#1F6B47',
  },
  error: {
    20: '#F5C9D1',
    50: tokens.colors.error.fg,
    60: tokens.colors.error.main,
    75: tokens.colors.error.bg,
    80: '#8C1E33',
    90: tokens.colors.error.fg,
  },
  warning: {
    20: tokens.colors.warning.bg,
    70: tokens.colors.warning.bg,
    80: tokens.colors.warning.fg,
  },
  text: {
    primary: tokens.colors.ink,
    secondary: tokens.colors.inkSecondary,
  },
  dark: {
    tertiary: '#182F3359',
    notes: {
      70: tokens.colors.inkSecondary,
    },
  },
  background: {
    dark: {
      20: tokens.colors.tableHeadBg,
    },
  },
};

export default palette;
